/*=========================================================================================
  File Name: moduleUnitGetters.js
  Description: Unit Module Getters
  ----------------------------------------------------------------------------------------
  Item Name: POS SYSTEM
  Author: SpeedCodeLabs
  Author URL: http://www.speedcodelabs.com
==========================================================================================*/

export default {
    GetAllUnits(state) {
      return state.units.data;
    },
  };
  